import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Meteor } from 'meteor/meteor';
import { Roles } from 'meteor/alanning:roles';
import { isEmpty } from 'lodash';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

const APIConfiguration = () => {
  const [settings, setSettings] = React.useState({});
  const [editmode, setEditmode] = React.useState(false);
  const userId = Meteor.userId();
  const isAdmin = Roles.userIsInRole(userId, 'admin');

  const fetchSettings = async () => {
    try {
      const APISettings = await methodPromise('admin.fetchAPISetting');
      if (APISettings.length > 0) {
        setSettings(APISettings[0]);
      } else {
        setSettings({
          deployConfigAPI: '',
          svgCategoryListAPI: '',
          sendUserLocationAPI: '',
          OGRLayerAPI: '',
          value: true
        });
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  React.useEffect(() => {
    fetchSettings();
  }, []);

  const handleSubmit = async event => {
    // event.preventDefault();
    let method = '';
    if (settings.value === true) {
      method = 'admin.addAPISetting';
    } else {
      method = 'admin.updateAPISetting';
    }

    const setting = {
      _id: settings._id,
      deployConfigAPI: event.target.deployConfigAPI.value,
      svgCategoryListAPI: event.target.svgCategoryListAPI.value,
      sendUserLocationAPI: event.target.sendUserLocationAPI.value,
      OGRLayerAPI: event.target.OGRLayerAPI.value,
      value: false
    };
    try {
      await methodPromise(method, setting);
      setSettings(setting);
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const Edit = () => {
    setEditmode(!editmode);
  };
  const Cancel = () => {
    setEditmode(!editmode);
    Window.location.reload();
    return false;
  };
  if (!isEmpty(settings)) {
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={6} lg={4}>
            <Form.Group>
              <Form.Label>SVG Category</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="svgCategoryListAPI"
                placeholder="Where is your service?"
                defaultValue={settings.svgCategoryListAPI}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>User Location</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="sendUserLocationAPI"
                placeholder="Where is your service?"
                defaultValue={settings.sendUserLocationAPI}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>OGR Layer API</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="OGRLayerAPI"
                placeholder="Where is your service?"
                defaultValue={settings.OGRLayerAPI}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Configuración del despligue</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="deployConfigAPI"
                placeholder="Where is your service?"
                defaultValue={settings.deployConfigAPI}
              />
            </Form.Group>
          </Col>
        </Row>
        <br />
        {isAdmin ? (
          <Form.Row className="d-flex">
            <Button disabled={editmode} variant="primary" onClick={Edit}>
              <FontAwesomeIcon icon="edit" size="lg" />
              {settings.value ? 'Add Setting' : 'Edit Setting'}
            </Button>
            <Button disabled={!editmode} type="submit" variant="success">
              <FontAwesomeIcon icon="save" size="lg" /> Save
            </Button>
            <Button disabled={!editmode} variant="danger" onClick={Cancel}>
              <FontAwesomeIcon icon="times" size="lg" /> Cancel
            </Button>
          </Form.Row>
        ) : (
          <> </>
        )}
      </Form>
    );
  }
  return <></>;
};

export default APIConfiguration;
